<template>
  <div
    class="notify-channels-overlay"
    :class="{ 'notify-channels-overlay--fixed': fixed }"
    @click.self="$emit('cancel')"
  >
    <div class="notify-channels-modal" role="dialog" aria-labelledby="notify-channels-title">
      <div class="notify-channels-header">
        <h3 id="notify-channels-title">Select channels</h3>
        <button type="button" class="notify-channels-close" title="Close" @click="$emit('cancel')">
          <font-awesome-icon :icon="['fas', 'times']" />
        </button>
      </div>

      <div v-if="loading" class="notify-channels-loading">Loading preferences…</div>

      <div v-else-if="!rows.length" class="notify-channels-empty">
        Add recipients before selecting channels.
      </div>

      <div v-else class="notify-channels-list">
        <div
          v-for="row in rows"
          :key="row.uid"
          class="notify-channels-row"
        >
          <div class="notify-channels-name">{{ row.name }}</div>
          <select
            class="notify-channels-select"
            :value="draft[row.uid]"
            @change="onChannelChange(row.uid, $event.target.value)"
          >
            <option
              v-for="opt in channelOptions"
              :key="opt.value"
              :value="opt.value"
            >
              {{ opt.label }}
            </option>
          </select>
        </div>
      </div>

      <div class="notify-channels-actions">
        <button type="button" class="notify-channels-cancel" @click="$emit('cancel')">
          Cancel
        </button>
        <button
          type="button"
          class="notify-channels-save"
          :disabled="!rows.length || loading"
          @click="$emit('save', { ...draft })"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { NOTIFY_CHANNEL_OPTIONS } from "@/utils/notifyChannels";

export default {
  name: "NotifyChannelsModal",
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
    draft: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    channelOptions() {
      return NOTIFY_CHANNEL_OPTIONS;
    },
  },
  methods: {
    onChannelChange(uid, value) {
      this.$emit("update-draft", { uid, channel: value });
    },
  },
};
</script>

<style scoped>
.notify-channels-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
  padding: 16px;
}

.notify-channels-overlay--fixed {
  position: fixed;
  z-index: 2147483647;
}

.notify-channels-modal {
  background: #fff;
  border-radius: 10px;
  width: 100%;
  max-width: 360px;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
}

.notify-channels-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #e9ecef;
}

.notify-channels-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #343a40;
}

.notify-channels-close {
  border: none;
  background: transparent;
  color: #6c757d;
  cursor: pointer;
  padding: 4px 6px;
}

.notify-channels-loading,
.notify-channels-empty {
  padding: 24px 16px;
  text-align: center;
  color: #6c757d;
  font-size: 14px;
}

.notify-channels-list {
  padding: 12px 16px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.notify-channels-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.notify-channels-name {
  flex: 1;
  min-width: 0;
  font-size: 14px;
  color: #495057;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notify-channels-select {
  flex-shrink: 0;
  min-width: 110px;
  padding: 6px 8px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 13px;
  background: #fff;
  color: #495057;
}

.notify-channels-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid #e9ecef;
}

.notify-channels-cancel,
.notify-channels-save {
  border-radius: 6px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}

.notify-channels-cancel {
  border: 1px solid #ced4da;
  background: #fff;
  color: #495057;
}

.notify-channels-save {
  border: none;
  background: #007bff;
  color: #fff;
}

.notify-channels-save:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
</style>
